var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Experience Segment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.043154,250.051372 L250.043154,250.108602 L250.057137,250.09777 L396.806543,452.4843 C481.313102,391.183594 521.240689,280.77432 488.70681,175.990311 L487.698726,172.816817 L250.043154,250.051372 Z",
    fill: "#C9BD2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceSegment);
export default __webpack_public_path__ + "static/media/Experience-Segment.29a9b80628aac52fc7f96d6ac871045a.svg";
export { ForwardRef as ReactComponent };